import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const FeaturedProducts = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios.get('/api/products/featured')
      .then(res => setProducts(res.data))
      .catch(err => console.error('Failed to load featured:', err));
  }, []);

  // ✅ If empty, hide the section completely
  if (!products || products.length === 0) return null;

  return (
    <section className="pb-20 py-10 bg-white">
      <div className="text-center mb-12">
      <p className="text-center uppercase mt-4 mb-0"
  style={{
    color: '#3b3d6e',
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '12px',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '19.8px',
    letterSpacing: '2.4px',
    transition: 'color 0.2s ease-in-out',
    WebkitFontSmoothing: 'antialiased',
  }}>Curated elegance just for you</p>
      <h2
  className="text-center uppercase mt-4 mb-0"
  style={{
    color: '#3b3d6e',
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '20px',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '33px',
    letterSpacing: '4px',
    transition: 'color 0.2s ease-in-out',
    WebkitFontSmoothing: 'antialiased',
  }}
>Featured Products</h2>
      
      </div>

      <div className="md:max-w-6xl mx-auto grid grid-cols-3 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-10 px-4">
      {products.map((product) => (
          <Link
            key={product._id}
            to={`/product/${product.productId}`}
            className="group cursor-pointer"
          >
            <img
              src={`/uploads/${product.photos?.[0]?.replace(/\\/g, '/')}`}
              alt={product.name}
              className="w-full h-[150px] sm:h-[250px] md:h-[300px] lg:h-[350px] xl:h-[380px]
 object-cover rounded-lg group-hover:scale-105 transition-transform duration-500"
            />
            <div className="mt-4 text-center">
              <h3 className="text-[12px] md:text-lg font-Montserrat, sans-serif">{product.name}</h3>
              <p className="text-[10px] md:text-sm mt-1">
  {typeof product.price === 'number'
    ? `$${product.price.toFixed(2)}`
    : 'Price unavailable'}
</p>



            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default FeaturedProducts;
